import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer, createMigrate } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';

// middleware
import thunkMiddleware from 'redux-thunk';

// reducers
import rootReducer from '../reducers';

// ----------------------
// 🔥 VERSION (IMPORTANT)
// ----------------------
const PERSIST_VERSION = 1;

// ----------------------
// 🔥 MIGRATIONS
// ----------------------
const migrations = {
  0: (state) => {
    return {
      ...state,
      device: undefined,
    };
  },

  1: (state) => {
    return {
      device: state && state.device
    };
  },
};

// ----------------------
// 🔥 PERSIST CONFIG
// ----------------------
const persistConfig = {
  key: 'root',
  version: PERSIST_VERSION,
  storage,
  stateReconciler: autoMergeLevel2,

  // ✅ only persist needed reducers
  whitelist: ['Intl', 'tenant', 'user', 'category', 'csa'],

  // ✅ FIXED migration (YOU WERE NOT USING createMigrate)
  migrate: createMigrate(migrations, { debug: false }),
};

// ----------------------
const persistedReducer = persistReducer(persistConfig, rootReducer);

// ----------------------
// 🔥 MIDDLEWARE
// ----------------------
const middleware = [thunkMiddleware];
const enhancers = [];

// ----------------------
// 🔥 REDUX DEVTOOLS
// ----------------------
if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

// ----------------------
const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

// ----------------------
// 🔥 STORE EXPORT
// ----------------------
export default () => {
  const store = createStore(persistedReducer, {}, composedEnhancers);

  const persistor = persistStore(store, null, () => {
    console.log('Persist rehydration complete');
  });

  return { store, persistor };
};